import React, { useEffect, useState, useRef, useCallback } from "react";
import { ToastContainer } from "react-toastify";

export const Addresses = (props) => {

  const contactInfo = props.contactData;

  return (
    <>
      <div id="contacts" className="mainContentData">
        <br></br>
        <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">Home Address</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 px-0">
          <div className="row m-0 gap-5">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> Address 1</span>
                <p className="fw-medium mb-0">
                  {contactInfo.homeAddressStreet1 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium"> Province</span>
                <p className="fw-medium mb-0">
                  {contactInfo.homeProvince || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> Address 2</span>
                <p className="fw-medium mb-0">
                  {contactInfo.homeAddressStreet2 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium"> Country</span>
                <p className="fw-medium mb-0">
                  {contactInfo.homeCountry || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> City</span>
                <p className="fw-medium mb-0">{contactInfo.homeCity || "-"}</p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Notes</span>
                <p className="fw-medium mb-0">{contactInfo.homeNote || "-"}</p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> State</span>
                <p className="fw-medium mb-0">{contactInfo.homeState || "-"}</p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Use for Invoicing</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    checked={contactInfo.homeUseforInvoicing === true}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Zip</span>
                <p className="fw-medium mb-0">{contactInfo.homeZip || "-"}</p>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">
                  Business Address
                </span>
                <p className="fw-medium mb-0"></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 px-0">
          <div className="row m-0 gap-5">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 1</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessAddressStreet1 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Province</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessProvince || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 2</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessAddressStreet2 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Country</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessCountry || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">City</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessCity || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Notes</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessNote || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">State</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessState || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Use for Invoicing</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    checked={contactInfo.businessUseforInvoicing === true}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium"> Zip</span>
                <p className="fw-medium mb-0">
                  {contactInfo.businessZip || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="col-lg-12 px-0">
          <div className="row m-0">
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium custom-font-size">
                  Statement Address
                </span>
                <p className="fw-medium mb-0"></p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 px-0">
          <div className="row m-0 gap-5">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 1</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressStreet1 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Province</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressProvince || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Address 2</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressStreet2 || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Country</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressCountry || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">City</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressCity || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Notes</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementNote || "-"}
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">State</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressState || "-"}
                </p>
              </div>
              <div className="mb-4">
                <span className="fw-medium">Use for Invoicing</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    checked={contactInfo.statementUseforInvoicing === true}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Zip</span>
                <p className="fw-medium mb-0">
                  {contactInfo.statementAddressZip || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer/>
    </>
  );
};
